import { HelpTab } from '../../components/about/HelpTab';

/**
 * Help screen: the shared FAQ tab rendered inside the dashboard main panel. The same component serves the public About page's Help tab, so both contexts always show identical content.
 *
 * @returns The help screen element.
 */
export function Help() {
  return <HelpTab />;
}
